export default __webpack_public_path__ + "static/identity-mock2-44cb0fe3562c041fd5201ec736f99618.png";